import { Routes } from '@angular/router';
import { Home } from './features/home/home.component';
import { ProfileSelection } from './features/profile-selection/profile-selection.component';
import { Questionnaire } from './features/questionnaire/questionnaire.component';
import { TermComponent } from './features/term/term.component';
import { ChoiceHistoryComponent } from './features/choice-history/choice-history.component';
import { TokenVerifyComponent } from './core/components/token-verify/token-verify.component';
import { NotFoundComponent } from './features/not-found/not-found.component';

export const routes: Routes = [
    { path: '', component: TokenVerifyComponent },
    { path: 'home', component: Home },
    { path: 'questionnaire', component: Questionnaire },
    { path: 'profile-selection', component: ProfileSelection },
    { path: 'term', component: TermComponent },
    { path: 'history', component: ChoiceHistoryComponent },
    { path: 'not-found', component: NotFoundComponent },
    { path: '**', redirectTo: 'not-found' },
];
